export default __webpack_public_path__ + "static/loans-image-e6a7dbc571dea92d09c15a097de788e1.png";